import {
  DataMarquee,
  type DataMarqueeEventData,
  type DataMarqueeProps,
  type DataMarqueeStatData,
} from '../../generic/DataMarquee/DataMarquee'

import {buildDataMarqueeItems} from './build-data-marquee-items'
import Styles from './DataMarqueeSection.module.css'

export type DataMarqueeSectionPropsData = Omit<DataMarqueeProps, 'items'> & {
  stats: DataMarqueeStatData[]
}

export interface DataMarqueeSectionProps extends DataMarqueeSectionPropsData {
  events: DataMarqueeEventData[]
}

export const defaultProps: Partial<DataMarqueeSectionProps> = {}

export const DataMarqueeSection = (props: DataMarqueeSectionProps) => {
  const initializedProps: DataMarqueeSectionProps = {...defaultProps, ...props}
  const {events, stats, ...dataMarqueeProps} = initializedProps
  const items = buildDataMarqueeItems(events, stats)

  return (
    <div className={Styles['DataMarqueeSection']}>
      <DataMarquee {...dataMarqueeProps} items={items} />
      <div className={Styles['DataMarqueeSection__Spacer']} />
    </div>
  )
}
